import { makeAutoObservable, observable  } from "mobx";
import _ from "underscore";
import { FlowsationPerformanceService } from "../services/FlowsationPerformanceService";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const currentDate = new Date();

class FlowstationPerformanceStore {
  constructor() {
    makeAutoObservable(this);
  }

  monthandYears = [];
  selMonth = currentDate.getMonth() + 1;
  selYear = currentDate.getFullYear();
  selMonthName = monthNames[currentDate.getMonth()];
  years = [];
  isLoading = false;
  flowstationProductions = observable.map({});
  flowstationCapacity = observable.map({});
  flowstationUtilization = observable.map({});
  totalOil = 0;
  totalGas = 0;
  totalGasBoe = 0;
  totalBoe = 0;
  activeOilStrings = 0;
  activeGasStrings = 0;
  activeTotalStrings = 0;
  async getInitialData() {
    try {
      this.isLoading = true;
      const retVal = await FlowsationPerformanceService.loadInitialData();
      const { monthandYear, years, maxMonth, maxYear } = retVal;
      const selectedMonth = Number(maxMonth) || currentDate.getMonth() + 1;
      const selectedYear = Number(maxYear) || currentDate.getFullYear();

      this.selMonth = selectedMonth;
      this.selMonthName = monthNames[selectedMonth - 1] || monthNames[currentDate.getMonth()];
      this.selYear = selectedYear;

      this.monthandYears = Array.isArray(monthandYear) ? monthandYear : [];
      this.years = Array.isArray(years) ? years : [];
      await this.getDashboardData();
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async getDashboardData() {
    try {
      this.isLoading = true;
      const retVal = await FlowsationPerformanceService.getDashboardData(
        this.selYear,
        this.selMonth
      );
      const {
        flowstationProduction,
        flowstationCapacity,
        flowstationUtilization,
        activeOilString,
        activeGasString,
        totalactiveString,
      } = retVal;
      this.flowstationProductions = flowstationProduction;
      console.log("flowstationProduction", flowstationProduction);
      const totalOil = _.reduce(
        _.map(flowstationProduction, (x) => x.oil_Volume),
        function (memo, num) {
          return memo + num;
        },
        0
      );
      const totalGas = _.reduce(
        _.map(flowstationProduction, (x) => x.gas_Volume),
        function (memo, num) {
          return memo + num;
        },
        0
      );
      const totalGasBoe = _.reduce(
        _.map(flowstationProduction, (x) => x.gasBoe),
        function (memo, num) {
          return memo + num;
        },
        0
      );
      const totalBoe = _.reduce(
        _.map(flowstationProduction, (x) => x.boe),
        function (memo, num) {
          return memo + num;
        },
        0
      );

      this.totalOil = totalOil;
      this.totalGas = totalGas;
      this.totalGasBoe = totalGasBoe;
      this.totalBoe = totalBoe;
      this.flowstationCapacity = flowstationCapacity;
      this.flowstationUtilization = flowstationUtilization;
      this.activeOilStrings = activeOilString;
      this.activeGasStrings = activeGasString;
      this.activeTotalStrings = totalactiveString;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
 //

const flowstationPerformance = new FlowstationPerformanceStore();
export default flowstationPerformance;

